module.exports = __webpack_public_path__ + "static/img/coin-off.4718e056.png";